import * as types from '@/store/mutation-types';
import _ from 'lodash';

const mutations = {
  [types.SET_FORM_BTN_TXT](state, p) {
    const drp = p.drp;
    drp[`${p.type}BtnTxt`] = p.text;
  },
  [types.SET_FORM_FIELD_LABEL](state, p) {
    let drp = p.drp;
    drp = _.find(drp.fields, { _id: p.activeId });
    drp.label = p.label;
  },
  [types.SET_FORM_FIELD_NO_LABEL](state, p) {
    let drp = p.drp;
    drp = _.find(drp.fields, { _id: p.activeId });
    drp.noLabel = p.noLabel;
  },
  [types.SET_FORM_FIELD_REQUIRED](state, p) {
    let drp = p.drp;
    drp = _.find(drp.fields, { _id: p.activeId });
    drp.required = p.required;
  },
  [types.SET_FORM_FIELD_TOOLTIP](state, p) {
    let drp = p.drp;
    drp = _.find(drp.fields, { _id: p.activeId });
    drp.toolTip = p.toolTip;
  },
  [types.SET_FORM_FIELD_PLACEHOLDER](state, p) {
    let drp = p.drp;
    drp = _.find(drp.fields, { _id: p.activeId });
    drp.placeholder = p.placeholder;
  },
  [types.SET_FORM_FIELD_OTHER](state, p) {
    let drp = p.drp;
    drp = _.find(drp.fields, { _id: p.activeId });
    drp.other = p.other;
  },
  [types.SET_FORM_FIELD_OPTION](state, p) {
    let drp = p.drp;
    drp = _.find(drp.fields, { _id: p.activeId });
    drp.options[p.index].value = p.value;
  },
  [types.REMOVE_FORM_FIELD_OPTION](state, p) {
    let drp = p.drp;
    drp = _.find(drp.fields, { _id: p.activeId });
    drp.options.splice(p.index, 1);
  },
  [types.ADD_FORM_FIELD_OPTION](state, p) {
    let drp = p.drp;
    drp = _.find(drp.fields, { _id: p.activeId });
    drp.options.push(p.option);
  },
  [types.SET_FORM_ACTIVE_FIELD](state, p) {
    const drp = p.drp;
    drp.editingField = true;
    drp.addingNewField = false;
    drp.activeField = p.activeField;
  },
  [types.SET_FORM_FIELD_EDIT_TABS](state, p) {
    const drp = p.drp;
    drp.editingField = p.editingField;
    drp.addingNewField = p.addingNewField;
  },
  [types.RESET_FORM_EDITING](state, p) {
    const drp = p.drp;
    drp.editingField = false;
    drp.addingNewField = true;
    drp.activeField = null;
  },
  [types.SET_FORM_ACTIVE_FIELD_ID](state, p) {
    const drp = p.drp;
    drp.activeFieldId = p.activeFieldId;
  },
  [types.SET_FORM_ACTIVE_FIELD_INDEX](state, p) {
    const drp = p.drp;
    drp.activeFieldIndex = p.activeFieldIndex;
  },
  [types.REMOVE_FORM_FIELD](state, p) {
    const drp = p.drp;
    drp.fields.splice(p.index, 1);
  },
  [types.ADD_FORM_COUNT](state, p) {
    if (p.page.type !== 'draft') {
      // we only want to add to the form count if not a draft
      if (p.site.forms) {
        const i = _.findIndex(p.site.forms, f => f === p.drp._id);
        if (i < 0) {
          p.site.forms.push(p.drp._id);
        }
      } else {
        this._vm.$set(p.site, 'forms', [p.drp._id]);
      }
    }
    const list = p.page.type !== 'draft' ? 'forms' : 'draftForms';
    if (p.page[list]) {
      const i = _.findIndex(p.page[list], f => f === p.drp._id);
      if (i < 0) {
        p.page[list].push(p.drp._id);
      }
    } else {
      this._vm.$set(p.page, list, [p.drp._id]);
    }
  },
};

const actions = {
  setFormBtnTxt: ({ commit }, payload) => {
    commit(types.SET_FORM_BTN_TXT, payload);
  },
  setFormFieldLabel: ({ commit }, payload) => {
    commit(types.SET_FORM_FIELD_LABEL, payload);
  },
  setFormFieldNoLabel: ({ commit }, payload) => {
    commit(types.SET_FORM_FIELD_NO_LABEL, payload);
  },
  setFormFieldRequired: ({ commit }, payload) => {
    commit(types.SET_FORM_FIELD_REQUIRED, payload);
  },
  setFormFieldTooltip: ({ commit }, payload) => {
    commit(types.SET_FORM_FIELD_TOOLTIP, payload);
  },
  setFormFieldPlaceholder: ({ commit }, payload) => {
    commit(types.SET_FORM_FIELD_PLACEHOLDER, payload);
  },
  setFormFieldOther: ({ commit }, payload) => {
    commit(types.SET_FORM_FIELD_OTHER, payload);
  },
  setFormFieldOption: ({ commit }, payload) => {
    commit(types.SET_FORM_FIELD_OPTION, payload);
  },
  removeFormFieldOption: ({ commit }, payload) => {
    commit(types.REMOVE_FORM_FIELD_OPTION, payload);
  },
  addFormFieldOption: ({ commit }, payload) => {
    commit(types.ADD_FORM_FIELD_OPTION, payload);
  },
  setFormFieldActive: ({ commit }, payload) => {
    commit(types.SET_FORM_ACTIVE_FIELD, payload);
  },
  setFormFieldActiveId: ({ commit }, payload) => {
    commit(types.SET_FORM_ACTIVE_FIELD_ID, payload);
  },
  setFormFieldActiveIndex: ({ commit }, payload) => {
    commit(types.SET_FORM_ACTIVE_FIELD_INDEX, payload);
  },
  removeFormField: ({ commit }, payload) => {
    commit(types.REMOVE_FORM_FIELD, payload);
  },
  setFormsEditTabs: ({ commit }, payload) => {
    commit(types.SET_FORM_FIELD_EDIT_TABS, payload);
  },
  resetFormEditing: ({ commit }, payload) => {
    commit(types.RESET_FORM_EDITING, payload);
  },
  addFormCount: ({ commit, rootState }, payload) => {
    payload.site = rootState.Websites.currentSite;
    payload.page = rootState.TopControlBar.currentPage;
    commit(types.ADD_FORM_COUNT, payload);
  },
};

export default {
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/form/vuex.js